<template>
  <v-card outlined class="tj-item-full" v-bind="$attrs">
    <v-card-title>
      <v-btn icon text :color="selected? 'primary': 'accent'" @click="onViewClick" v-if="showIcon">
        <v-icon>mdi-eye</v-icon>
      </v-btn>
      <p class="ml-2 text-h6">{{titulo}}</p>
    </v-card-title>
    <v-card-text>
      <div><strong>Assunto:</strong> {{ assunto }}</div>
      <div><strong>Classe:</strong> {{ classe }}</div>
      <div><strong>Competência:</strong> {{ competencia }}</div>
      <div><strong>Magistrado:</strong> {{ magistrado }}</div>
      <p class="text-subtitle-2">Sentença:</p>
      <div class="pa-2 text-body-2 texto-sentenca" 
        :class="hasHeight? 'texto-scroll': 'texto-auto'" 
        :style="{ 'max-height': theTextHeight }" 
        v-html="sentenca" />
    </v-card-text>
  </v-card>
  
</template>

<script>
import Vue from "vue"

export default Vue.component("tj-item-full", {
  props: {
    item: Object,
    textHeight: [String, Number],
    selected: Boolean,
    showIcon: Boolean
  },

  computed: {
    titulo(){
      return this.item? this.item.titulo: ""
    },

    assunto(){
      return this.item? this.item.assunto: ""
    },

    classe(){
      return this.item? this.item.classe: ""
    },

    competencia(){
      return this.item? this.item.competencia: ""
    },

    magistrado(){
      return this.item? this.item.magistrado: ""
    },

    sentenca(){
      return this.item? this.item.sentenca: ""
    },

    theTextHeight(){
      return this.textHeight || "auto" 
    },

    hasHeight(){
      return this.textHeight != null && ("" + this.textHeight).length > 0
    }

  },

  methods: {
    onViewClick(){
      this.$emit("view", this.item)
    }
  }
  
})
</script>

<style>
  .tj-item-full .v-card__text {
    position:relative;
  }
  .tj-item-full .texto-sentenca {
    min-height: 10rem;
  }

  .tj-item-full .texto-scroll {
    overflow-y: scroll;
  }

  .tj-item-full .texto-auto {
    overflow-y: auto;
  }

</style>